import { UserPartnerCompanyQueryKeysEnum } from '../components/ProfileCard/hooks/usePartnerCompanyList/types';

export const QUERIES = [
  UserPartnerCompanyQueryKeysEnum.INITIAL_MAIN_PARTNER_COMPANIES_STATE,
  UserPartnerCompanyQueryKeysEnum.INITIAL_PARTNER_COMPANIES_STATE,
];
